export default __webpack_public_path__ + "static/media/cardsandchips111.e3bb92b9.png";